import { render, staticRenderFns } from "./ConsumableList.vue?vue&type=template&id=d8769648&scoped=true"
import script from "./ConsumableList.vue?vue&type=script&lang=js"
export * from "./ConsumableList.vue?vue&type=script&lang=js"
import style0 from "./ConsumableList.vue?vue&type=style&index=0&id=d8769648&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8769648",
  null
  
)

export default component.exports